import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { NB_sidebar_props, SidebarItem } from "./interface";
import { NbSidebarView } from "./view/sidebarView";
import { findActiveItemFromPath } from "../../helpers/sidebar";

export const NbSidebar = ({
  onClickItemList = () => {},
  onIsHideSideBar = () => {},
  activeItem: externalActiveItem,
  ...props
}: NB_sidebar_props) => {
  const location = useLocation();
  const [isHidden, setIsHidden] = useState(props.hideSidebar);
  const [itemsSidebar, setItemsSidebar] = useState<SidebarItem[]>(
    props.sidebarItemsList || []
  );
  const [activeItem, setActiveItem] = useState<string | null>(
    externalActiveItem ||
      itemsSidebar
        .flatMap((item) => item.children)
        .find((child) => child.active)?.id ||
      null
  );
  const [isHiddenList, setIsHiddenList] = useState<Record<string, boolean>>(
    itemsSidebar?.reduce((acc: any, item) => {
      acc[item.id] = item.header?.hideList ?? false;
      return acc;
    }, {})
  );

  useEffect(() => {
    setItemsSidebar(props.sidebarItemsList || []);
  }, [props.sidebarItemsList]);

  useEffect(() => {
    if (externalActiveItem) return;
    const computedActive = findActiveItemFromPath(
      location.pathname,
      props.sidebarItemsList || []
    );
    setActiveItem(computedActive);
  }, [externalActiveItem, location.pathname, props.sidebarItemsList]);

  useEffect(() => {
    setIsHidden(props.hideSidebar);
  }, [props.hideSidebar]);

  useEffect(() => {
    if (externalActiveItem) {
      setActiveItem(externalActiveItem);
    }
  }, [externalActiveItem]);

  useEffect(() => {
    onIsHideSideBar(isHidden || false);
  }, [isHidden, onIsHideSideBar]); // eslint-disable-line react-hooks/exhaustive-deps

  const hideDrawer = () => {
    setIsHidden((prev) => !prev);
  };

  const hideList = (id: string) => {
    setIsHiddenList((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const selectedItem = (item: any) => {
    setActiveItem(item.id);
    onClickItemList?.(item);
  };

  return (
    <NbSidebarView
      {...props}
      isHidden={isHidden}
      isHiddenList={isHiddenList}
      itemsSidebar={itemsSidebar}
      activeItem={activeItem}
      hideList={hideList}
      hideDrawer={hideDrawer}
      selectedItem={selectedItem}
    />
  );
};
